<div class="container">
  <div class="page-container">
    <header class="section-header-question">
      <mds-icon
        [key]="icons.REQUEST_INFORMATION"
        [width]="40"
        [height]="40"
        [pathColors]="[colors.SECONDARY]"
      ></mds-icon>
      <h3 class="section-title">Requested product information</h3>
    </header>

    <!-- Description -->
    <p class="section-desc">Please find the details for the request below.</p>

    <!-- Content Row -->
    <div class="content-row">
      <!-- Product Information -->
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <mds-icon
              [key]="icons.PRODUCT_INFORMATION"
              [width]="30"
              [height]="30"
              [pathColors]="[colors.SECONDARY]"
            ></mds-icon>
            <span>Product information</span>
          </div>
        </div>
        <div class="card-body">
          <div class="info-row">
            <div class="label">Name</div>
            <div class="value">{{ response?.info?.product?.name || '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">MPN</div>
            <div class="value">{{ response?.info?.product?.prop_MPN || '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Product Group Part Number</div>
            <div class="value">{{ response?.info?.product?.prop_PN || '-' }}</div>
          </div>
        </div>
      </div>
      <!-- Company Information -->
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <mds-icon
              [key]="icons.COMPANY_INFORMATION"
              [width]="30"
              [height]="30"
              [pathColors]="[colors.SECONDARY]"
            ></mds-icon>
            <span>Company information</span>
          </div>
        </div>
        <div class="card-body">
          <div class="info-row">
            <div class="label">Name</div>
            <div class="value">{{ response?.info?.company?.requestor_name || '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Completion date by</div>
            <div class="value">
              {{
                response?.info?.company?.requested_completion_date
                  ? (response?.info?.company?.requested_completion_date | utcDate: 'dd/MM/yyyy')
                  : '-'
              }}
            </div>
          </div>
          <div class="info-row">
            <div class="label">Contact person</div>
            <div class="value">{{ response?.info?.company?.requestor_contact_name || '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Contact email</div>
            <div class="value">{{ response?.info?.company?.requestor_contact_email || '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Phone number</div>
            <div class="value">{{ response?.info?.company?.requestor_contact_phone || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Section: Upload -->
  <section class="section-upload">
    <header class="section-header-question">
      <mds-icon [key]="icons.UPLOAD" [width]="40" [height]="40" [pathColors]="[colors.SECONDARY]"></mds-icon>
      <h3 class="section-title">Upload data</h3>
    </header>
    <p class="section-desc">
      Manage the data you want to include here. The questionnaire table below will update dynamically based on the
      content of your uploaded file.
    </p>
    <input type="file" #fileInput hidden (change)="onFileSelected($event)" />
    <ng-container *ngIf="!response.info.bom_file && editable">
      <div
        class="upload-box"
        (drop)="onFileDropped($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        [class.dragover]="isDragging"
      >
        <mds-icon [key]="icons.UPLOAD" [width]="48" [height]="58" [pathColors]="[colors.SECONDARY]"></mds-icon>
        <p>
          Drop your file here or
          <span class="browse-text" (click)="fileInput.click()">browse</span>
        </p>
        <small>Supports all file types</small>
        <ng-container *ngIf="uploadedFileName">
          <div class="uploaded-file-name">
            {{ uploadedFileName }}
          </div>
        </ng-container>
      </div>

      <div class="action-container" *ngIf="editable">
        <ng-container *ngTemplateOutlet="uploadHelper"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="response.info.bom_file">
      <div class="file-card">
        <div class="file-icon">
          <mds-icon [key]="icons.ATTACHMENT" [width]="24" [height]="24" [pathColors]="[colors.PRIMARY]"></mds-icon>
        </div>

        <!-- File details -->
        <div class="file-details">
          <div class="file-info">
            <div class="file-name">{{ response.info.bom_file.name }}</div>
          </div>
          <!-- Actions -->
          <div class="file-actions">
            <mds-icon
              [key]="icons.DOWNLOAD"
              [width]="24"
              [height]="24"
              [pathColors]="[colors.TERTIARY]"
              (click)="downloadBom()"
            ></mds-icon>
          </div>
        </div>
      </div>
      <div class="action-container" *ngIf="editable">
        <ng-container *ngTemplateOutlet="uploadHelper"></ng-container>
        <div class="actions">
          <mds-button
            (click)="fileInput.click()"
            type="secondary"
            icon="sync"
            [isIconLeft]="true"
            aria-label="Replace file"
          >
            Replace file
          </mds-button>
        </div>
      </div>
    </ng-container>
  </section>
  <!-- Section: Questionnaire -->
  <section class="section">
    <header class="section-header-question">
      <mds-icon [key]="icons.QUESTIONNAIRE" [width]="40" [height]="40" [pathColors]="[colors.SECONDARY]"></mds-icon>
      <h3 class="section-title">{{ isUserExternalSupplier ? 'Questionnaire' : 'Received answer' }}</h3>
    </header>
    <p class="section-desc">
      {{
        isUserExternalSupplier
          ? 'Manage the data you want to include here. The questionnaire table below will update dynamically based on the
      content of your uploaded file.'
          : 'The supplier has answered your request with the following data structure. At every last-level node they’ve declared one or more substances for SCIP declaration.'
      }}
    </p>
    <div class="compliance-container">
      <mds-grid
        *ngIf="gridOverrides"
        [overrides]="gridOverrides"
        [minHeight]="'600px'"
        [sizeColumnsToFit]="true"
        [storageKey]="'scip-questionnaire'"
        [themeClass]="'ag-theme-material'"
        (gridReady)="onGridReady($event)"
      ></mds-grid>
      <app-no-data *ngIf="!gridOverrides" [data]="emptyData"></app-no-data>
    </div>
  </section>
</div>
<ng-template #uploadHelper>
  <div class="info-button" (click)="openLink()">
    <mds-icon [key]="icons.INFO" [width]="20" [height]="20" [pathColors]="[colors.CONTENT_QUATERNARY]"></mds-icon>
    <span class="label">How to prepare upload files</span>
    <mds-icon
      [key]="icons.OPEN_IN_NEW"
      [width]="20"
      [height]="20"
      [pathColors]="[colors.CONTENT_QUATERNARY]"
    ></mds-icon>
  </div>
  <div class="actions">
    <mds-button
      type="secondary"
      icon="download"
      [isIconLeft]="true"
      aria-label="Download template"
      (click)="downloadTemplate()"
    >
      Download template
    </mds-button>
  </div>
</ng-template>
